import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../hooks';
import { useField } from '@unform/core';
import { EstoqueOperacoesService } from '../services/api/estoque/estoqueOperacoes/EstoqueOperacoesService';

type TAutoCompleteOption = {
  idoperacoes: string;
  label: string;
  faturamento: boolean;
  tipo: number;
}

interface IAutoCompleteOperacoesProps {
  isExternalLoading?: boolean;
  disabled?: boolean;
  faturamento?: (novoTextoselect: boolean | undefined) => void;
  venda?: (novoTextoselect: boolean | undefined) => void;
  tipo?: (novoTextoselect: number | undefined) => void;
  ajuste?: (novoTextoselect: boolean | undefined) => void;
  operacao?: (novoTextoselect: string | undefined) => void;
  idoperacao?: (novoId: string | undefined) => void;
}

export const AutoCompleteOperacoes01: React.FC<IAutoCompleteOperacoesProps> = ({ isExternalLoading = false, disabled = false, faturamento, tipo, operacao }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField('idoperacoes');
  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);

  useEffect(() => {
    setIsLoading(true);

    debounce(() => {
      EstoqueOperacoesService.getAlllist(busca, selectedId, 3)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(operacoes => ({ idoperacoes: operacoes.idoperacoes, label: operacoes.descricao, tipo: operacoes.tipo, faturamento: operacoes.faturamento })));
          }
        });
    });
  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(
      (opcao) => opcao && opcao.idoperacoes === selectedId
    );

    return selectedOption ?? null;
  }, [selectedId, opcoes]);


  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={disabled}
      value={autoCompleteSelectedOption}
      // Só busca sozinho por `reason==='input'` — ver AutoCompleteMunicipio.tsx pro caso
      // completo do loop que isso evita (reset automático do MUI virando busca).
      onInputChange={(_, newValue, reason) => {
        if (reason === 'input') setBusca(newValue);
      }}
      onChange={(_, newValue) => {
        setSelectedId(newValue?.idoperacoes); faturamento?.(newValue?.faturamento); setSelectedId(newValue?.idoperacoes);
        tipo?.(newValue?.tipo); operacao?.(newValue?.label); setBusca(''); clearError();
      }}
      popupIcon={(isExternalLoading || isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Operações"
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};